export const NewsArticle = ({title, href, date, thumbnail, source}) => {
    return (
        <a className={'NewsArticle'}
           href={href}
           target={'_blank'}
           rel={'noreferrer'}
        >
            <div className={'NewsArticle__thumbnail'}>
                {
                    thumbnail
                        ? <img src={thumbnail} alt={''}/>
                        : <div className={'NewsArticle__thumbnail-placeholder'}/>
                }
                <div className={'NewsArticle__date'}>
                    {new Date(date).toLocaleDateString()}
                </div>
            </div>
            {
                source &&
                <div className={'NewsArticle__source'}>{source}</div>
            }
            <div className={'NewsArticle__title'}>{title}</div>
        </a>
    )
}

export default NewsArticle;
